import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "../lib/site";
import SectionHeading from "../components/SectionHeading";
import useDocumentTitle from "../hooks/useDocumentTitle";

export default function MentionsLegales() {
  useDocumentTitle("Mentions légales — Voltis Électricité");
  return (
    <div data-testid="mentions-page" className="bg-white">
      <section className="container-x py-16 lg:py-24 max-w-3xl">
        <SectionHeading
          eyebrow="Informations"
          title="Mentions légales."
        />
        <div className="prose prose-slate mt-10 space-y-6 text-slate-700">
          <div>
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-2">Éditeur du site</h3>
            <p>{SITE.brand} — Électricien certifié<br />Zone d'intervention : votre ville et alentours</p>
          </div>
          <div>
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-2">Contact</h3>
            <p>
              Téléphone : <a href={`tel:${SITE.phoneTel}`} className="text-[#CA8A04] hover:underline">{SITE.phoneDisplay}</a><br />
              Email : <a href={`mailto:${SITE.email}`} className="text-[#CA8A04] hover:underline">{SITE.email}</a>
            </p>
          </div>
          <div>
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-2">Hébergement</h3>
            <p>Le site est hébergé par un prestataire conforme RGPD.</p>
          </div>
          <div>
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-2">Données personnelles</h3>
            <p>Les informations transmises via le formulaire de contact sont utilisées uniquement pour répondre à votre demande. Vous disposez d'un droit d'accès, de rectification et de suppression de vos données.</p>
          </div>
          <div>
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-2">Propriété intellectuelle</h3>
            <p>L'ensemble des contenus du site (textes, images, charte graphique) sont la propriété de {SITE.brand}. Toute reproduction sans autorisation est interdite.</p>
          </div>
          <div className="pt-6">
            <Link to="/" className="text-[#CA8A04] hover:underline font-semibold">← Retour à l'accueil</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
